<template>
  <div>
    <div class="h-100 lh-1 vg-th-inner" :style="'width: '+width+'px;position: relative; overflow: initial;'">
      <span ref="content">
        
          <v-tooltip top open-delay="800">
      <template v-slot:activator="{ on }">
        <span class="gridHeaderCellLabel" v-on="on" @click="changeColumnOrder">{{value}}</span>
      </template>
      <span>{{col.sortOrder==''?'Sort descending':col.sortOrder=='desc'?'Sort ascending':'Remove sort'}}</span>
    </v-tooltip>
         <v-icon color="grey lighten-1" :style="'font-size:14px;opacity:'+(col.sortOrder!=''?1:0)+';'">{{col.sortOrder=='desc'?'mdi-arrow-down':'mdi-arrow-up'}}</v-icon> 
         <v-icon color="grey lighten-1" :style="'color:#01b7a8 !important;font-size:14px;opacity:'+(is_filtered!=''?1:0)+';'">mdi-filter-variant</v-icon> 
      </span>
      <grid-header-cell-menu :label="value" @toggleDropdown="$emit('showDropdown')" @apply="applyFilter" :sortOrder="col.sortOrder" :showDropdown="col.showDropdown"></grid-header-cell-menu>
    </div>

    <div
      class="absolute top-0 bottom-0 right-0 cursor-resize-ew"
      :style="'width: '+column_resize_handle_width+'px'"
      @mousedown="onColumnResizerMousedown"
    ></div>
  </div>
</template>

<script>
  import GridHeaderCellMenu from './GridHeaderCellMenu'
  import {
    COLUMN_RESIZE_HANDLE_WIDTH
  } from './constants'

  export default {
    components:{
      GridHeaderCellMenu
    },
    props: {
      'col': {
        type: Object,
        required: true
      },
      'value': {
        required: true
      },
      'width': {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        content_width: 0,
        column_resize_handle_width: COLUMN_RESIZE_HANDLE_WIDTH,
        is_filtered:false
      }
    },
    mounted() {
      var el = this.$refs['content']
      this.content_width = el ? el.offsetWidth : 0
      this.$emit('determine-auto-width', this.col, this.content_width)
    },
    methods: {
      applyFilter(filter){
        this.is_filtered = filter.operator !=''
        this.$emit('applyFilter',filter)
      },
      changeColumnOrder(){
        this.$emit('sort',this.col.sortOrder ==''?'desc':(this.col.sortOrder=='desc'?'asc':''))

      },
      onColumnResizerMousedown() {
        this.$emit('column-resizer-mousedown', this.col)
      }
    }
  }
</script>
